// extracted by mini-css-extract-plugin
export default {"tabs":"TabsComponent_tabs__IkMm-"};